import { useState } from "react";
import { Zap, X } from "lucide-react";
import { Button } from "@/components/primitives/button";
import { useStartSubscriptionView } from "@/hooks/useStartSubscriptionView";
import { SubscriptionPlan } from "@/server/types/subscription";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface PlanLimitUpsellProps {
  message: string;
  targetPlan?: SubscriptionPlan;
  className?: string;
}

export default function PlanLimitUpsell({
  message,
  targetPlan = "standard",
  className,
}: PlanLimitUpsellProps) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);
  const startSubscriptionView = useStartSubscriptionView();

  if (dismissed) {
    return null;
  }

  const planLabel = targetPlan.charAt(0).toUpperCase() + targetPlan.slice(1);

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-lg border border-accent/30 bg-accent/10 px-3 py-2",
        className,
      )}
    >
      <Zap size={14} className="shrink-0 text-secondary" />
      <p className="flex-1 text-xs text-foreground/80">
        {message}{" "}
        <button
          type="button"
          onClick={() => startSubscriptionView()}
          className="font-semibold text-secondary underline-offset-2 hover:underline"
        >
          {t("subscription.upgradePrompt", { plan: planLabel })}
        </button>
      </p>
      <Button
        size="icon"
        variant="ghost"
        className="size-5 shrink-0 text-muted-foreground hover:text-foreground"
        onClick={() => setDismissed(true)}
        aria-label={t("dismiss")}
      >
        <X size={12} />
      </Button>
    </div>
  );
}
